<template>
  <div class="container-fluid">
    <br>
    <a @click="$router.go(-1)" class="btn-default btn">
      <i class="fa fa-times"></i>
      {{ $t('words.cancel') }}
    </a>
    <button type="button" :disabled="loading" @click="saveData()" class="btn btn-success float-right">
      <i class="fa fa-check"></i>
      {{$t('words.save')}}
      <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
    </button>
    <br>
    <br>
    <div class="card card-outline card-outline-tabs" :class="appLayout.card">
      <div class="card-header p-0 border-bottom-0">
        <div class="nav-tabs-custom" role="tabpanel">
          <!-- Nav tabs -->
          <div class="nav nav-tabs" role="tablist">
            <li role="presentation" class="nav-item">
              <a class="nav-link active"> <i class="fa fa-sitemap"></i>
                {{ $t('words.post_data')}}</a>
            </li>
          </div>
        </div>
      </div>
      <!-- Tab panes -->
      <div class="card-body">
        <div class="tab-content">
          <div class="tab-pane active" id="tabFormulario">
            <span v-html="$t('validation.field_required')"></span>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <required /> <label>{{ $t('attributes.name') }}</label>
                  <input name="name" :class="{'is-invalid': errors.has('name')}" :placeholder="$t('words.type_name')" v-validate="{required: true, max:60}"
                    v-model="cargo.cargo_nome" type="text" class="form-control">
                  <div class="invalid-feedback help-block error">{{errors.first('name')}}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('words.description') }}</label>
                  <input name="description" :class="{'is-invalid': errors.has('description')}" v-validate="{required: false, max:191}"
                    v-bind:placeholder="$t('words.type_description')" v-model="cargo.cargo_descricao" type="text"
                    class="form-control">
                  <div class="invalid-feedback help-block error">{{errors.first('description')}}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <p v-html="$t('message.post_permission', {'name':cargo.cargo_nome})"></p>
              <div class="info-box" style="min-height:100px">
                <span class="info-box-icon bg-red" style="min-height:100px;line-height:100px"><i
                    class="fa fa-lock"></i></span>
                <div class="row container-fluid">
                  <div v-for="(item, i) in permissions" :key="i" class="col-md-3 col-sm-3">
                    <div class="form-group">
                      <p-check class="p-switch p-fill" v-model="cargo.permissoes" :value="item.id"
                        :color="appLayout.check">
                        <strong>{{item.display_name}}</strong></p-check>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
  /* eslint-disable no-console */
  /* eslint-disable no-undef */
  export default {
    data() {
      return {
        cargo: {
          cargo_nome: null,
          cargo_descricao: null,
          cargo_ambiente: 1,
          permissoes: [],
        },
        loading: false,
      };
    },
    watch: {
      $route() {
        if (this.$route.name === 'cargoEdit') {
          this.getById();
        } else {
          this.resetForm();
        }
      }
    },
    mounted() {
      this.$store.dispatch('getCargoPermissions').then(response => {
        this.$store.commit('SET_CARGO_PERMISSIONS', response);
      });
    },
    beforeMount() {
      if (this.$route.name === 'cargoEdit') {
        this.getById();
      }
    },
    computed: {
      permissions() {
        return this.$store.state.cargo.permissions;
      },
    },
    methods: {
      saveData() {
        this.loading = true;
        this.$validator.validateAll().then(valid => {
          if (valid) {
            this.$route.name === 'cargoEdit' ? this.editData() : this.storeData();
          } else {
            this.loading = false;
            $('[href="#tabFormulario"]').tab('show');
          }
        });
      },
      storeData() {
        this.$store
          .dispatch('storeCargo', this.cargo)
          .then(data => {
            this.loading = false;
            if (data.status === 'success') {
              toastr({
                icon: data.status,
                title: data.message
              });
              this.resetForm();
            }
          });
      },
      editData() {
        this.$store
          .dispatch('updateCargo', this.cargo)
          .then(response => {
            this.loading = false;
            if (response.status === 'success') {
              toastr({
                icon: response.status,
                title: response.message
              });
              this.$router.push('/cargos');
            }
          });
      },
      resetForm() {
        Object.assign(this.$data, this.$options.data());
        this.$validator.reset();
      },
      getById() {
        this.$store
          .dispatch('getCargoById', this.$route.params.id)
          .then(response => {
            this.cargo = response;
            // this.verifyChecks();
          });
      },
      removeSelected(array) {
        this.cargo.permissoes = this.cargo.permissoes.filter(item => array.findIndex(x => x.id == item) ===
          -
          1);
      }
    }
  };
</script>